import { CurrencyCodes } from '@monetize/types/common';
import { boolean, object, string, z } from 'zod';

export interface ICurrencyResp {
  id: string;
  code: CurrencyCodes;
  description: string;
  locked: boolean;
  defaultCurrency: boolean;
}

export const CurrencySchema = object({
  code: string().nonempty(),
  description: string().nullish(),
  defaultCurrency: boolean(),
});
export type ICurrencySchema = z.infer<typeof CurrencySchema>;
